import { Badge, Spin, Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import React from 'react';
import {
  arrayOf, bool, func, number, shape,
} from 'prop-types';
import I18n from 'i18n-js';
import CommentItem from './CommentItem';

const { Text } = Typography;

const publiclyRepliedIds = (comments) => new Set(
  comments.filter((item) => item.parentId && !item.internal).map((item) => item.parentId),
);

const CommentList = ({
  ticketId,
  comments = [],
  loading = false,
  onUpdate = null,
  canSetInternalComment = false,
  canReply = false,
  onReply = (_id, _internal) => {},
  onCommentDraftChange = (_id, _hasDraft) => {},
}) => {
  const commentsById = new Map(comments.map((item) => [item.id, item]));
  const repliedPublicly = publiclyRepliedIds(comments);

  return (
    <div className="ticket-comments-list">
      <Spin spinning={loading}>
        <div className="ticket-comments-list__header">
          <CommentOutlined className="ticket-comments-list__header-icon" />
          <Text strong>
            {I18n.t('ticket_comments.title')}
          </Text>
          <Badge count={comments.length} className="ticket-comments-list__badge" />
        </div>

        <div className="ticket-comments-list__items">
          {comments.map((item) => (
            <CommentItem
              key={item.id}
              {...item}
              ticketId={ticketId}
              replyTo={commentsById.get(item.parentId) ?? null}
              hasPublicReplies={repliedPublicly.has(item.id)}
              onUpdate={onUpdate}
              canSetInternalComment={canSetInternalComment}
              canReply={canReply}
              onReply={onReply}
              onDraftChange={onCommentDraftChange}
            />
          ))}
        </div>
      </Spin>
    </div>
  );
};

CommentList.propTypes = {
  ticketId: number.isRequired,
  comments: arrayOf(shape({})),
  loading: bool,
  onUpdate: func,
  canSetInternalComment: bool,
  canReply: bool,
  onReply: func,
  onCommentDraftChange: func,
};

export default CommentList;
